<form #formEdit="ngForm">
    <div class="EmptyBox30"></div>
    <div class="TexAlCenter">
        <div>
            <div class="WhiteBack" style="border-radius: 4px; padding: 22px 0">
                <div style="text-align: end; margin-right: 10px;">
                    <i18n-selector></i18n-selector>
                </div>
                <div style="margin-bottom: 10px;">
                    <img height="80" alt="Logo" [src]="logoImage" />
                </div>
                <div class="d-flex TexAlLeft">
                    <div class="d-col"></div>
                    <div>
                        <!-- login -->
                        <div class="MarV">
                            <span class="p-input-icon-right">
                                <input pInputText [(ngModel)]="login" placeholder="{{v('auth_user')}}" name="_login"
                                    #_login="ngModel" required size="20" class="BsFsMedium" />
                                <i class="pi pi-users Black BsFsXLarge" (click)="op.toggle($event)"></i>
                            </span>
                            <p-message *ngIf="_login.invalid&&_login.touched" severity="error"
                                styleClass="BsSpaceL"></p-message>
                            <p-overlayPanel #op [dismissable]="true" class="WidAutoOnMobile">
                                <ng-template pTemplate>
                                    <skitbs-users></skitbs-users>
                                </ng-template>
                            </p-overlayPanel>
                        </div>
                        <div class="EmptyBox5"></div>

                        <!-- password -->
                        <div class="MarV">
                            <p-password [(ngModel)]="passwd" placeholder="{{v('auth_password')}}" name="pwd"
                                #pwd="ngModel" required size="20" [feedback]="false" [toggleMask]="true"
                                inputStyleClass="BsFsMedium"></p-password>
                            <p-message *ngIf="pwd.invalid&&pwd.touched" severity="error"
                                styleClass="BsSpaceL"></p-message>
                        </div>
                    </div>
                    <div class="d-col"></div>
                </div>

                <div style="margin: 20px 0 10px 0;" class="TexAlCenter">
                    <p-checkbox [(ngModel)]="cookieUseConfirmed" [binary]="true" label="{{i18n.v('cookie_confirmation')}}" name="cookieUseConfirmed" (onChange)="cookieConfirmationChanged($event)"></p-checkbox>
                    <div class="EmptyBox5"></div>
                    <button pButton label="Login" (click)="onLogin()" [disabled]="!formEdit.form.valid || !cookieUseConfirmed"
                        class="PadWithBorder5" style="width: 190px;" iconPos="left"></button>
                    <div class="EmptyBox5"></div>
                    <button pButton label="{{v('password_change')}}" (click)="onChangePassword()"
                        class="PadAll MarB p-button-danger MarT" style="width: 190px;"></button>
                    <div class="EmptyBox5"></div>
                    <a pButton label="{{v('new_customer')}}" href="{{'REGISTRATION_URL' | env}}" target="_blank" class="PadAll MarB MarT"
                        style="text-decoration: none; width: 190px;"></a>
                    <div *ngIf="privacyStatementConfirmed">
                        <div class="EmptyBox5"></div>
                        <a pButton label="Chatbot" target="_blank" (click)="botFrameVisible = true" class="PadAll MarB MarT"
                        style="text-decoration: none; width: 190px;" *ngIf="botLinkVisible"
                        >
                            <img src="assets/icons/bot-white.svg" height="16px">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!privacyStatementConfirmed">
        <div class="EmptyBox5"></div>
        <div class="WidAutoOnMobile White" style="background: rgba(255, 255, 255, .2); border-radius: 4px;">
            <div class="EmptyBox5"></div>
            <p style="padding: 0px 10px 0px 10px" class="TexAlCenter">
                Bitte stimmen Sie der Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie in unserer <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/dataprotection_de.pdf" target="_blank"
                    style="color: #fff; cursor: pointer;">{{v('dataProtection_statement')}}</a>.
                <button pButton label="{{v('dataProtection_statement_confirm')}}" (click)="onConfirmPrivacyStatement()" class="p-button-success" style="vertical-align: baseline;"></button>
            </p>
            <div class="EmptyBox5"></div>
        </div>
    </div>
    <div class="EmptyBox5"></div>
    <div class="WidAutoOnMobile White" style="background: rgba(255, 255, 255, .2); border-radius: 4px;">
        <div class="EmptyBox5"></div>
        <div class="TexAlCenter">
            <div class="flip TexAlCenter">
                <a (click)="router.navigate(['/contact'])" target="_blank" style="color: #fff; text-decoration: none; cursor: pointer;">{{v('contact')}}</a>
                <span class="flip"> | </span> 
            </div>
            <div class="flip TexAlCenter">
                <a (click)="router.navigate(['/imprint'])" target="_blank" style="color: #fff; text-decoration: none; cursor: pointer;">{{v('imprint')}}</a>
                <span class="flip"> | </span>
            </div>
            <div class="flip TexAlCenter">
                <a (click)="router.navigate(['/disclaimer'])" target="_blank" style="color: #fff; text-decoration: none; cursor: pointer;">{{v('disclaimer')}}</a>
                <span class="flip"> | </span>
            </div>
            <div class="flip TexAlCenter">
                <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/dataprotection_de.pdf" target="_blank"
                    style="color: #fff; text-decoration: none; cursor: pointer;">{{v('dataProtection')}}</a>
                <span class="flip"> | </span>
            </div>
            <div class="flip TexAlCenter">
                <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/transparenzerklaerung.pdf" target="_blank"
                    style="color: #fff; text-decoration: none; cursor: pointer;">{{v('transparencyStatement')}}</a>
            </div>
        </div>

        <p style="padding: 0px 10px 0px 10px"  class="TexAlCenter">
            <i class="fa fa-copyright"></i> 2014–{{year}} food safety qualITy GmbH
            <br /> Alle Rechte vorbehalten.
        </p>
        <p style="padding: 0px 10px 0px 10px"  class="TexAlCenter">
            Kundenservice<br />
            E-Mail: {{'TENANT_SVC_EMAIL' | env}}<br />
            Telefon: {{'TENANT_SVC_PHONE' | env}}<br />
            Mo-Fr 07:00 bis 16:00
        </p>
        <div class="EmptyBox5"></div>
    </div>
    <!-- iOS Home screen tooltip -->
    <skitbs-ios-tooltip></skitbs-ios-tooltip>

    <p-dialog [(visible)]="botFrameVisible" position="right" [resizable]=false>
        <iframe
            src="https://web.powerva.microsoft.com/environments/Default-74921e6f-35b2-40fb-803d-53715777c223/bots/crd7d_richtlinienUndVollmachten/webchat?_version_=2"
            height="600" width="350"
        >
        </iframe>
    </p-dialog>

</form>
